import { FC } from 'react';
import ConfirmModal from 'components/molecules/ConfirmModal';
import GatewayStatus from 'components/pages/AssetPage/Tabs/TabGateway/GatewayStatus';
import { useGatewayDetailInfo } from './resources/useGatewayDetailInfo';
import SkeletonAtom from 'components/atoms/SkeletonAtom';

const TabInfo: FC = () => {
  const {
    gateway,
    translations,
    rebootOptions,
    onUpdateGateway,
    loading,
  } = useGatewayDetailInfo();

  const {
    rebootGatewayLiterals: {
      rebootGatewayModalText,
      rebootGatewayModalTitle,
      rebootGatewayModalMainButtonText,
      rebootGatewayModalSecondaryButtonText,
    },
    onRebootGateway,
    onCancelRebootGateway,
    onConfirmRebootGateway,
    isRebootGatewayLoading,
    isRebootGatewayModalVisible,
    hasPermissionToRebootGateway,
    isConfirmRebootGatewayButtonDisabled,
  } = rebootOptions;

  return (
    <>
      {!!loading && (
        <SkeletonAtom active />
      )}
      {!!gateway && !loading && (
        <GatewayStatus
          gateway={gateway}
          informationTranslations={translations}
          onUnassignGateway={() => { }}
          onUpdateGateway={onUpdateGateway}
          onRebootGateway={() => onRebootGateway(gateway.isRebootable, gateway.id)}
          hasPermissionToEditGatewayLink={false}
          isGatewayLinked={true}
          hasPermissionToRebootGateway={hasPermissionToRebootGateway}
        />
      )}
      <ConfirmModal
        text={rebootGatewayModalText}
        title={rebootGatewayModalTitle}
        mainButtonText={rebootGatewayModalMainButtonText}
        secondaryButtonText={rebootGatewayModalSecondaryButtonText}
        onCancel={onCancelRebootGateway}
        onClickMainButton={onConfirmRebootGateway}
        loading={isRebootGatewayLoading}
        visible={isRebootGatewayModalVisible}
        isMainButtonDisabled={isConfirmRebootGatewayButtonDisabled}
      />
    </>
  );
};

export default TabInfo;
